export default function AppHeader({ title }) {
    return (
        <h1> { title } </h1>
    )
}